export const hardcodedSupportCommunitiesFallback = [
  { slug: "kreechures", name: "Kreechures", collectionPublicKey: "", isDefault: true }
];

export function normalizeSupportCommunities(value) {
  if (!Array.isArray(value)) return [];

  return value
    .map((row) => ({
      slug: String(row?.slug || "").trim(),
      name: String(row?.name || "").trim(),
      collectionPublicKey: String(row?.collectionPublicKey ?? row?.collection_public_key ?? "").trim(),
      isDefault: Boolean(row?.isDefault ?? row?.is_default)
    }))
    .filter((row) => row.slug && row.name);
}

export function parseSupportCommunitiesFallback(raw = import.meta.env.VITE_SUPPORT_COMMUNITIES_FALLBACK_JSON) {
  try {
    const parsed = JSON.parse(String(raw || ""));
    const normalized = normalizeSupportCommunities(parsed);
    return hasKreechuresCommunity(normalized) ? normalized : fallbackRows();
  } catch {
    if (import.meta.env.DEV) console.warn("support_communities.fallback_used");
    return fallbackRows();
  }
}

export function defaultSupportCommunity(communities) {
  const normalized = normalizeSupportCommunities(communities);
  return (
    normalized.find((row) => row.isDefault) ||
    normalized.find((row) => row.slug === "kreechures") ||
    normalized[0] ||
    hardcodedSupportCommunitiesFallback[0]
  );
}

export function supportCommunityNameForMarket(market) {
  return String(market?.supportCommunityName || "").trim() || "Kreechures";
}

function hasKreechuresCommunity(communities) {
  return communities.some((row) => row.slug === "kreechures" && row.name);
}

function fallbackRows() {
  return hardcodedSupportCommunitiesFallback.map((row) => ({ ...row }));
}
